<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
    extends: Line,
    name: "line-chart",
    mixins: [reactiveProp],
    props: ['options'],
    mounted () {
        this.renderChart(this.chartData, this.options)
    },
    watch: {
        chartData () {
            this.$data._chart.update()
        }
    }
}
</script>

<style>
</style>